export const RACK_TYPES = ['mech', 'hps', 'eps'];
/** Короткая метка на плашках: МЕХ / ГУР / ЭУР */
export const RACK_TYPE_SHORT = { mech: 'МЕХ', hps: 'ГУР', eps: 'ЭУР' };
/** В подписи после артикула: «РК-0124 · с ГУР» */
export const RACK_TYPE_LONG = { mech: 'механическая', hps: 'с ГУР', eps: 'с ЭУР' };
/** Заголовок карточки типа: «Механическая», «С ГУР» */
export const RACK_TYPE_TITLE = { mech: 'Механическая', hps: 'С ГУР', eps: 'С ЭУР' };
/** В характеристиках: «с гидроусилителем» */
export const RACK_TYPE_FULL = {
    mech: 'без усилителя',
    hps: 'с гидроусилителем',
    eps: 'с электроусилителем',
};
/** Для названия товара: «Рейка с ГУР Toyota Camry» */
export const RACK_TYPE_PRODUCT = {
    mech: 'Рейка механическая',
    hps: 'Рейка с ГУР',
    eps: 'Рейка с ЭУР',
};
export const STEERING = ['left', 'right'];
export const STEERING_LABEL = { left: 'левый руль', right: 'правый руль' };
export const COMPLETENESS = ['none', 'rods', 'rods_ends'];
export const COMPLETENESS_LABEL = {
    none: 'без тяг',
    rods: 'с тягами',
    rods_ends: 'с тягами и наконечниками',
};
export const CONDITIONS = ['restored', 'new', 'used'];
export const CONDITION_LABEL = {
    restored: 'Восстановлена',
    new: 'Новая',
    used: 'Контрактная (б/у, проверена)',
};
/** Что заменили при восстановлении — галочки в карточке товара */
export const REPLACED_PARTS = [
    'Сальники и уплотнения',
    'Опорные втулки',
    'Пыльники',
    'Зубчатая пара',
    'Ремкомплект распределителя',
    'Подшипники ЭУР',
    'Датчик момента',
];
/** Чек-лист комплектности при приёмке */
export const INTAKE_CHECKLIST = ['Рулевые тяги', 'Наконечники', 'Пыльники', 'Трубки ГУР', 'Разъём и датчики ЭУР', 'Кронштейны'];
/** Параметры протокола стенда по умолчанию */
export const BENCH_PARAMS = [
    { name: 'Герметичность под давлением', tolerance: '' },
    { name: 'Усилие поворота', tolerance: '' },
    { name: 'Люфт в центре', tolerance: '' },
    { name: 'Полный ход рейки', tolerance: '' },
    { name: 'Возврат в центр', tolerance: '—' },
    { name: 'Посторонние шумы', tolerance: 'нет' },
];
//# sourceMappingURL=rack.js.map